import store from '../store/store';

export default class ApiError extends Error {
    messages = {
        // General errors
        // These are defined in lang files so they can be translated

        // Auth errors
        'AUTH-UNE': 'An account with this email address doesn\'t exist',
        'AUTH-UAI': 'User account is inactive',
        'AUTH-UAL': 'User account is locked',
        'AUTH-IAT': 'Authorization token invalid or expired',
        'AUTH-IVT': 'Verification token invalid or expired',
        'AUTH-IVC': 'Verification code invalid or expired',
        'AUTH-IEM': 'You must sign up with the email address that the invitation was sent to',
        'AUTH-TNE': 'This signup invitation has expired and can no longer be used. Please ask your organization to send you a new invitation.',
        'AUTH-AHM': 'Authorization header not set',
        'AUTH-UNA': 'You are not authorized to perform this action',
        'AUTH-IUC': 'Incorrect password',
        'AUTH-PWD': 'Password does not meet the minimum security requirements',
        'AUTH-PRR': 'Password has expired and must be reset',
        'AUTH-IRT': 'This password reset link has expired',
        'AUTH-AAC': 'An account already exists with this email address',
        'AUTH-LAE': 'Too many login attempts',
        'AUTH-BCD': 'Login and signup are temporarily disabled',
        'AUTH-ISC': 'This signup code has expired and can no longer be used',

        // User errors
        'USER-MRI': 'Missing required user information',
        'USER-INE': 'Email is invalid',
        'USER-UNE': 'User does not exist',
        'USER-UAE': 'This user already belongs to another organization and cannot be invited',

        // Organization errors
        'ORG-MRI': 'Missing required organization information',
        'ORG-ONE': 'The requested organization no longer exists',
        'ORG-ATL': 'API authentication token limit reached',

        // Form errors
        'FORM-MRI': 'Missing required form information',
        'FORM-BBM': 'This file type is not supported for background images',
        'FORM-BIM': 'This file type is not supported for images',
        'FORM-FNE': 'The selected form no longer exists',
        'FORM-FIC': 'Form name contains invalid characters',
        'FORM-FND': 'This draft has already been published or discarded by another user',
        'FORM-MSS': 'This form has been modified by another user since you began editing and can no longer be overwritten',
        'FORM-PGF': 'An internal error occurred while creating this PDF',
        'FORM-BPF': 'An error occurred while processing the uploaded file',

        // Path errors
        'PATH-MRI': 'Missing required form/folder information',
        'PATH-PAE': 'A form or folder with this name already exists',
        'PATH-FIC': 'Form/folder name contains invalid characters',
        'PATH-PNF': 'The target path is not a folder',
        'PATH-PNE': 'This folder is not empty and cannot be deleted',
        'PATH-DNE': 'This folder no longer exists',

        // Filler errors
        // These are defined in lang files so they can be translated

        // Package errors
        // Moved to lang files

        // Data element errors
        'ELEM-MRI': 'The request failed because some required information was missing',
        'ELEM-PDN': 'Permission Denied',

        // Payment errors
        // Moved to lang files

        // Service plan limit errors
        'LIM-USR': `Your organization has reached the maximum number of teammates for its service plan. Outstanding teammate invitations count towards the limit, and can be deleted if you need to invite or activate another user.`,
        'LIM-FRM': `Your organization has reached the maximum number of forms for its service plan.`,
        'LIM-BOX': `Your organization has reached the maximum number of shared boxes for its service plan.`,
        'LIM-SHR': `Your organization does not have inbox sharing included in its service plan.`,
    };

    constructor(errorCode, httpCode, httpText, details = null) {
        super(errorCode);
        this.message = store.getters['lang/tr'][errorCode]
            || this.messages[errorCode]
            || errorCode
            || 'Server error';
        this.name = `${httpCode} ${httpText}`;
        this.code = errorCode;
        this.httpCode = httpCode;
        this.details = details;
    }
}